import Icon from './Icon';
import * as React from 'react';
import { appConfigStore } from 'Models/AppConfigStore';

export function FreightIcon({ className }: { className?: string }) {
	return <Icon name={appConfigStore.freightIconName} classname={`freight__icon ${className}`} useMaterialIcons />;
}
